// extracted by mini-css-extract-plugin
export default {"backGroundImage":"style_backGroundImage__VyRaY","borderSelected":"style_borderSelected__rMT+x","borderUnSelected":"style_borderUnSelected__2635B"};